import React, { useEffect, useRef } from "react";
import "./TPMS_7.css";

function TPMS_7() {
  const row1 = useRef(null);
  const row2 = useRef(null);
  const row3 = useRef(null);
  const row4 = useRef(null);
  const row5 = useRef(null);
  const row6 = useRef(null);
  const row7 = useRef(null);
  const row8 = useRef(null);
  const row9 = useRef(null);
  const row10 = useRef(null);

  const allRows = [row1, row2, row3, row4, row5, row6, row7, row8, row9, row10];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.15 }
    );

    allRows.forEach((ref) => {
      if (ref.current) observer.observe(ref.current);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="core-features-subtle">
      
      <div className="tp-wrap">
        {/* ===== SECTION HEADER ===== */}
        <div className="cf-header">
          <span className="cf-eyebrow">CORE FEATURES</span>
          <h2 className="cf-h21">
            Next Gen <span>TPMS Experience</span>
          </h2>
          <p className="cf-subtitle">
            Powered by AI-driven intelligence for complete toll operations
            control
          </p>
        </div>

        {/* ===== FEATURE ROWS ===== */}
        <div className="cf-rows">
          
          {/* ── 01 ── AI-Based Real-Time Monitoring */}
          <div className="cf-row" ref={row1}>
            <div className="cf-img-wrap">
              <div className="cf-dot-bracket top-left"></div>
              <div className="cf-dot-bracket bottom-right"></div>
              
              <div className="cf-img-inner">
                <div className="bgg4">
                 <img
                  src="ImagesNew/feature-monitoring3.jpeg"
                  alt="AI-Based Real-Time Monitoring"
                  loading="lazy"
                />
                </div>
              </div>
              <span className="cf-tag">LIVE MONITORING</span>
            </div>
            
            <div className="cf-content">
              <span className="cf-num">01</span>
              <h3>AI-Powered Vehicle Detection and Tracking</h3>
              <p>
                 Automatically identify and track vehicles through monitored toll lanes, including slow-moving and temporarily stationary traffic.
              </p>
              <button className="cf-btn">
                Explore More <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>

          {/* ── 02 ── Vehicle & Axle Detection */}
          <div className="cf-row cf-row--reverse" ref={row2}>
            <div className="cf-img-wrap">
              <div className="cf-dot-bracket top-right"></div>
              <div className="cf-dot-bracket bottom-left"></div>

              <div className="cf-img-inner">
                <div className="bgg4">
                <img
                  src="ImagesNew/feature-detection-LR.jpeg"
                  alt="Vehicle and Axle Detection"
                  loading="lazy"
                />
                </div>
              </div>
              <span className="cf-tag">OCR + AI</span>
            </div>
            <div className="cf-content">
              <span className="cf-num">02</span>
              <h3>Intelligent Vehicle Classification</h3>
              <p>
                 Identify vehicle categories such as cars, buses, light commercial vehicles, and heavy trucks to support toll classification verification.
              </p>
              <button className="cf-btn">
                Explore More <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>

          {/* ── 03 ── FASTag Verification System */}
          <div className="cf-row" ref={row3}>
            <div className="cf-img-wrap">
              <div className="cf-dot-bracket top-left"></div>
              <div className="cf-dot-bracket bottom-right"></div>

              <div className="cf-img-inner">
                <div className="bgg4">
                <img
                  src="ImagesNew/feature-fastag-LR.jpeg"
                  alt="FASTag Verification System"
                  loading="lazy"
                />
                </div>
              </div>
              <span className="cf-tag">FASTAG VERIFY</span>
            </div>
            <div className="cf-content">
              <span className="cf-num">03</span>
              <h3>Automated Evidence Capture</h3>
              <p>
                Capture and retain vehicle images, selected video footage, and structured vehicle records to support investigation, verification, and reporting.
              </p>
              <button className="cf-btn">
                Explore More <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>

          {/* ── 04 ── Fraud Detection & Exemption Control */}
          <div className="cf-row cf-row--reverse" ref={row4}>
            <div className="cf-img-wrap">
              <div className="cf-dot-bracket top-right"></div>
              <div className="cf-dot-bracket bottom-left"></div>

              <div className="cf-img-inner">
                <div className="bgg4">
                <img
                  src="ImagesNew/feature-fraud-LR.jpeg"
                  alt="Fraud Detection and Exemption Control"
                  loading="lazy"
                />
                </div>
              </div>
              <span className="cf-tag">FRAUD PREVENT</span>
            </div>
            <div className="cf-content">
              <span className="cf-num">04</span>
              <h3>Toll Fraud Detection and Prevention Support</h3>
              <p>
                Enable operators to compare independent vehicle-monitoring records with toll transactions to identify missing entries, classification discrepancies, and suspicious exemptions.

              </p>
              <button className="cf-btn">
                Explore More <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>

          {/* ── 05 ── Centralized Dashboard & Analytics */}
          <div className="cf-row" ref={row5}>
            <div className="cf-img-wrap">
              <div className="cf-dot-bracket top-left"></div>
              <div className="cf-dot-bracket bottom-right"></div>

              <div className="cf-img-inner">
                <div className="bgg4">
                <img
                  src="ImagesNew/dashboard-LR-1.jpeg"
                  alt="Centralized Dashboard and Analytics"
                  loading="lazy"
                />
                </div>
              </div>
              <span className="cf-tag">ANALYTICS</span>
            </div>
            <div className="cf-content">
              <span className="cf-num">05</span>
              <h3>Exempted Vehicle Monitoring</h3>
              <p>
                Monitor multiple toll plazas from a single dashboard with
                real-time insights on traffic, revenue, and performance metrics
                at your fingertips.
              </p>
              <button className="cf-btn">
                Explore More <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>

          {/* ── 06 ── Audit-Ready Reports */}
          <div className="cf-row cf-row--reverse" ref={row6}>
            <div className="cf-img-wrap">
              <div className="cf-dot-bracket top-right"></div>
              <div className="cf-dot-bracket bottom-left"></div>

              <div className="cf-img-inner">
                <div className="bgg4">
                <img
                  src="ImagesNew/reports-LR.jpeg"
                  alt="Audit-Ready Reports"
                  loading="lazy"
                />
                </div>
              </div>
              <span className="cf-tag">REPORTS</span>
            </div>
            <div className="cf-content">
              <span className="cf-num">06</span>
              <h3>License Plate Recognition</h3>
              <p>
                Extract registration details from suitable captured images using AI-based number plate recognition, with validation and confidence-based review.

              </p>
              <button className="cf-btn">
                Explore More <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>

          {/* ── 07 ── Role-Based Secure Access */}
          <div className="cf-row" ref={row7}>
            <div className="cf-img-wrap">
              <div className="cf-dot-bracket top-left"></div>
              <div className="cf-dot-bracket bottom-right"></div>

              <div className="cf-img-inner">
                <div className="bgg4">
                <img
                  src="ImagesNew/Hero-Image-LR.png"
                  alt="Role-Based Secure Access"
                  loading="lazy"
                />
                </div>
              </div>
              <span className="cf-tag">SECURITY</span>
            </div>
            <div className="cf-content">
              <span className="cf-num">07</span>
              <h3>Heavy Vehicle Analysis</h3>
              <p>
                Support specialized heavy-vehicle monitoring and optional axle-analysis workflows where the relevant module is deployed.

              </p>
              <button className="cf-btn">
                Explore More <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>

          {/* ── 08 ── Cloud-Based Multi-Plaza System */}
          <div className="cf-row cf-row--reverse" ref={row8}>
            <div className="cf-img-wrap">
              <div className="cf-dot-bracket top-right"></div>
              <div className="cf-dot-bracket bottom-left"></div>

              <div className="cf-img-inner">
                <div className="bgg4">
                <img
                  src="ImagesNew/feature-fastag-LR.jpeg"
                  alt="Cloud-Based Multi-Plaza System"
                  loading="lazy"
                />
                </div>
              </div>
              <span className="cf-tag">CLOUD</span>
            </div>
            <div className="cf-content">
              <span className="cf-num">08</span>
              <h3>Multi-Lane Monitoring</h3>
              <p>
                Monitor vehicle activity across multiple toll lanes through a centralized platform.
              </p>
              <button className="cf-btn">
                Explore More <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>

          <div className="cf-row" ref={row9}>
  <div className="cf-img-wrap">
    <div className="cf-dot-bracket top-left"></div>
    <div className="cf-dot-bracket bottom-right"></div>

              <div className="cf-img-inner">
                <div className="bgg4">
                <img
                  src="ImagesNew/feature-fastag-LR.jpeg"
                  alt="Cloud-Based Multi-Plaza System"
                  loading="lazy"
                />
                </div>
              </div>
              <span className="cf-tag">CLOUD</span>
            </div>
            <div className="cf-content">
              <span className="cf-num">09</span>
              <h3>Video Recovery and Reprocessing</h3>
              <p>
                Process retained recordings to recover analysis following interruptions and support comprehensive historical verification.
              </p>
              <button className="cf-btn">
                Explore More <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>

          <div className="cf-row cf-row--reverse" ref={row10}>
  <div className="cf-img-wrap">
    <div className="cf-dot-bracket top-right"></div>
    <div className="cf-dot-bracket bottom-left"></div>

              <div className="cf-img-inner">
                <div className="bgg4">
                <img
                  src="ImagesNew/feature-fastag-LR.jpeg"
                  alt="Cloud-Based Multi-Plaza System"
                  loading="lazy"
                />
                </div>
              </div>
              <span className="cf-tag">CLOUD</span>
            </div>
            <div className="cf-content">
              <span className="cf-num">10</span>
              <h3>Centralized Dashboard and Reports</h3>
              <p>
                Access vehicle information, traffic records, monitoring statistics, operational status, and reporting features from one interface.
              </p>
              <button className="cf-btn">
                Explore More <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default TPMS_7;